import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Loading from './Loading'
import HardWindowRedirect from './HardWindowRedirect'
import { employeeHomeHref, isEmployeeHardNavHomePath } from '../utils/employeeDeskPath'

interface ProtectedRouteProps {
  children: React.ReactNode
  requireAdmin?: boolean
  /** Системная ИИ-аналитика: admin или Zam (см. canAccessFleetAiAnalytics) */
  requireFleetAiAnalytics?: boolean
  /** Доска постановки задач 2.0: admin или сотрудник с флагом в карточке (Zam/Control) */
  requireTaskBoardV2?: boolean
  /** КреоПортал: admin или галочка creative_portal_access в карточке сотрудника */
  requireCreativePortal?: boolean
  /** Generic server-issued capability required by the route. */
  requirePermission?: string
}

export default function ProtectedRoute({
  children,
  requireAdmin = false,
  requireFleetAiAnalytics = false,
  requireTaskBoardV2 = false,
  requireCreativePortal = false,
  requirePermission,
}: ProtectedRouteProps) {
  const {
    isAuthenticated,
    isAdmin,
    loading,
    canAccessFleetAiAnalytics,
    canAccessTaskBoardV2,
    canAccessCreativePortal,
    user,
    hasPermission,
  } = useAuth()

  if (loading) {
    return <Loading fullScreen text="Загрузка..." />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (requireFleetAiAnalytics) {
    if (isAdmin || canAccessFleetAiAnalytics) {
      return <>{children}</>
    }
    const href = employeeHomeHref(user)
    if (isEmployeeHardNavHomePath(href)) {
      return <HardWindowRedirect href={href} />
    }
    return <Navigate to={href} replace />
  }

  if (requireTaskBoardV2) {
    if (isAdmin || canAccessTaskBoardV2) {
      return <>{children}</>
    }
    const href = employeeHomeHref(user)
    if (isEmployeeHardNavHomePath(href)) {
      return <HardWindowRedirect href={href} />
    }
    return <Navigate to={href} replace />
  }

  if (requireCreativePortal) {
    if (isAdmin || canAccessCreativePortal) {
      return <>{children}</>
    }
    const href = employeeHomeHref(user)
    if (isEmployeeHardNavHomePath(href)) {
      return <HardWindowRedirect href={href} />
    }
    return <Navigate to={href} replace />
  }

  if (requirePermission && !hasPermission(requirePermission)) {
    const href = employeeHomeHref(user)
    if (isEmployeeHardNavHomePath(href)) {
      return <HardWindowRedirect href={href} />
    }
    return <Navigate to={href} replace />
  }

  if (requireAdmin && !isAdmin) {
    const href = employeeHomeHref(user)
    if (isEmployeeHardNavHomePath(href)) {
      return <HardWindowRedirect href={href} />
    }
    return <Navigate to={href} replace />
  }

  return <>{children}</>
}
